export default __webpack_public_path__ + "static/media/my_journey_part1_5.226883a0.png";